import { Merchant } from '@nemuru-eng/js-api-client';

import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';
import { ICON_NAMES } from '@/config/config';
import { MerchantInStructure } from '@/types/MerchantInStructure';

export const MerchantMap = {
  toSelectItem: (merchant: Merchant): SelectItem => {
    return {
      id: merchant.id,
      name: merchant.registrationFields.businessName,
      icon: ICON_NAMES.MERCHANT,
    };
  },
  toPartialMerchantInStructure: (merchant: Merchant): MerchantInStructure => {
    return {
      id: merchant.id,
      businessName: merchant.registrationFields.businessName,
      businessPhone: merchant.registrationFields.phoneNumber,
      businessAddress: '',
      category: merchant.registrationFields.category,
      channels: [],
    };
  },
};
